import { useState, useEffect } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "./ui/dialog";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordDialog({ mustChange }) {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(!!mustChange);
  const [form, setForm] = useState({ current: "", next: "" });
  useEffect(() => { if (mustChange) setOpen(true); }, [mustChange]);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Mot de passe modifié");
      if (user?.must_change_password) setUser({ ...user, must_change_password: false });
      setOpen(false); setForm({ current: "", next: "" });
    } catch (e2) { toast.error(formatApiError(e2.response?.data?.detail)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full border-[#1E3A8A]/30 text-[#1E3A8A]" data-testid="open-change-password">
          <KeyRound className="w-4 h-4 mr-1.5" /> Changer mon mot de passe
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Changer mon mot de passe</DialogTitle>
          <DialogDescription>Choisissez un nouveau mot de passe d'au moins 6 caractères.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label className="text-sm">Mot de passe actuel</Label><Input required type="password" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} className="rounded-xl mt-1.5" data-testid="current-password" /></div>
          <div><Label className="text-sm">Nouveau mot de passe (6+ caractères)</Label><Input required minLength={6} type="password" value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} className="rounded-xl mt-1.5" data-testid="new-password" /></div>
          <Button type="submit" className="w-full rounded-full bg-[#1E3A8A] hover:bg-[#14265E]" data-testid="submit-change-password">Confirmer</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
